module.exports = {"341102001":"琅琊街道","341102004":"丰山街道","341102006":"清流街道","341102007":"扬子街道","341102010":"西涧街道","341102011":"遵阳街道","341102012":"滁阳街道","341102013":"三官街道","341102400":"安徽滁州琅琊经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341102.json
// module id = 1217
// module chunks = 0